/**
 * @generated SignedSource<<a58e478851c9d27b77484e39f4ee6d91>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LockGrantType = "ANONYMOUS" | "ORGANIZATION" | "USER" | "%future added value";
export type UtilizationGrantPermission = "END_ON_OPEN" | "END_RENTAL" | "UNLOCK" | "%future added value";
export type sharedAccessPageQuery$variables = {
  hubName: string;
  reservationId: string;
};
export type sharedAccessPageQuery$data = {
  readonly hubMeta: {
    readonly city: string;
    readonly hub: {
      readonly id: string;
    };
    readonly id: string;
    readonly name: string;
    readonly postalCode: string;
    readonly street: string;
  };
  readonly reservation: {
    readonly id?: string;
    readonly space?: {
      readonly frame: string;
      readonly id: string;
      readonly position: number;
    };
    readonly subtype?: {
      readonly __typename: string;
    };
    readonly utilizationGrants?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly permissions: ReadonlyArray<UtilizationGrantPermission>;
        readonly toEmail: string | null | undefined;
        readonly toOrganization: {
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly toUser: {
          readonly email: string;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly ty: LockGrantType;
      }>;
    } | null | undefined;
  } | null | undefined;
};
export type sharedAccessPageQuery = {
  response: sharedAccessPageQuery$data;
  variables: sharedAccessPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "reservationId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "hubName"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Hub",
  "kind": "LinkedField",
  "name": "hub",
  "plural": false,
  "selections": [
    (v2/*:: as any*/)
  ],
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "reservationId"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "subtype",
  "plural": false,
  "selections": [
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "Space",
  "kind": "LinkedField",
  "name": "space",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "frame",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "active": true
      }
    },
    {
      "kind": "Literal",
      "name": "pagination",
      "value": {
        "page": 0,
        "pageSize": 1000
      }
    }
  ],
  "concreteType": "UtilizationGrantPage",
  "kind": "LinkedField",
  "name": "utilizationGrants",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UtilizationGrant",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ty",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "permissions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "toUser",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Organization",
          "kind": "LinkedField",
          "name": "toOrganization",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toEmail",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "utilizationGrants(filter:{\"active\":true},pagination:{\"page\":0,\"pageSize\":1000})"
},
v13 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "String"
},
v14 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedAccessPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*:: as any*/),
          "concreteType": "HubMeta",
          "kind": "LinkedField",
          "name": "hubMeta",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            (v4/*:: as any*/),
            (v5/*:: as any*/),
            (v6/*:: as any*/),
            {
              "kind": "RequiredField",
              "field": (v7/*:: as any*/),
              "action": "THROW"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              {
                "kind": "CatchField",
                "field": (v12/*:: as any*/),
                "to": "NULL"
              }
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sharedAccessPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "HubMeta",
        "kind": "LinkedField",
        "name": "hubMeta",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v8/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "reservation",
        "plural": false,
        "selections": [
          (v9/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*:: as any*/),
              (v10/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/)
            ],
            "type": "LockReservation",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "852332c078f534cefb5c975c8b4720cb",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.city": (v13/*:: as any*/),
        "hubMeta.hub": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Hub"
        },
        "hubMeta.hub.id": (v14/*:: as any*/),
        "hubMeta.id": (v14/*:: as any*/),
        "hubMeta.name": (v13/*:: as any*/),
        "hubMeta.postalCode": (v13/*:: as any*/),
        "hubMeta.street": (v13/*:: as any*/),
        "reservation": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Reservation"
        },
        "reservation.__typename": (v13/*:: as any*/),
        "reservation.id": (v14/*:: as any*/),
        "reservation.space": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Space"
        },
        "reservation.space.frame": (v13/*:: as any*/),
        "reservation.space.id": (v14/*:: as any*/),
        "reservation.space.position": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Int"
        },
        "reservation.subtype": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "LockReservationSubtype"
        },
        "reservation.subtype.__typename": (v13/*:: as any*/),
        "reservation.utilizationGrants": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "UtilizationGrantPage"
        },
        "reservation.utilizationGrants.nodes": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrant"
        },
        "reservation.utilizationGrants.nodes.id": (v14/*:: as any*/),
        "reservation.utilizationGrants.nodes.permissions": {
          "enumValues": [
            "END_RENTAL",
            "UNLOCK",
            "END_ON_OPEN"
          ],
          "nullable": false,
          "plural": true,
          "type": "UtilizationGrantPermission"
        },
        "reservation.utilizationGrants.nodes.toEmail": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "String"
        },
        "reservation.utilizationGrants.nodes.toOrganization": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "Organization"
        },
        "reservation.utilizationGrants.nodes.toOrganization.id": (v14/*:: as any*/),
        "reservation.utilizationGrants.nodes.toOrganization.name": (v13/*:: as any*/),
        "reservation.utilizationGrants.nodes.toUser": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "User"
        },
        "reservation.utilizationGrants.nodes.toUser.email": (v13/*:: as any*/),
        "reservation.utilizationGrants.nodes.toUser.id": (v14/*:: as any*/),
        "reservation.utilizationGrants.nodes.toUser.name": (v13/*:: as any*/),
        "reservation.utilizationGrants.nodes.ty": {
          "enumValues": [
            "USER",
            "ORGANIZATION",
            "ANONYMOUS"
          ],
          "nullable": false,
          "plural": false,
          "type": "LockGrantType"
        }
      }
    },
    "name": "sharedAccessPageQuery",
    "operationKind": "query",
    "text": "query sharedAccessPageQuery(\n  $hubName: String!\n  $reservationId: UUID!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    name\n    street\n    city\n    postalCode\n    hub {\n      id\n    }\n  }\n  reservation(id: $reservationId) {\n    __typename\n    ... on LockReservation {\n      id\n      subtype {\n        __typename\n      }\n      space {\n        id\n        frame\n        position\n      }\n      utilizationGrants(filter: {active: true}, pagination: {page: 0, pageSize: 1000}) {\n        nodes {\n          id\n          ty\n          permissions\n          toUser {\n            id\n            name\n            email\n          }\n          toOrganization {\n            id\n            name\n          }\n          toEmail\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c3ffc8ce4d1ae8e83489d8546d4db899";

export default node;
